module.exports = __webpack_public_path__ + "static/subscribe-dd90b6d83d1e52ebbb6f826d2560966a.png";